import { css } from '@emotion/react';

export const container = css`
  list-style-type: none;

  display: flex;
  flex-direction: column;
  gap: 8px;

  padding: 10px;

  &.isCollapsed {
    padding: 0 8px;
 }
`;
